export function init() {
  var mql = window.matchMedia('(min-width: 768px)');

  const videos = document.querySelectorAll('[data-video]');

  setPoster(mql.matches);

  mql.onchange = (e) => {
    setPoster(e.matches);
  };

  function setPoster(isDesktop) {
    videos.forEach((video) => {
      const posterDesktop = video.dataset.posterDesktop;
      const posterMobile = video.dataset.posterMobile;
      if (isDesktop) {
        video.poster = posterDesktop;
      } else {
        video.poster = posterMobile ? posterMobile : posterDesktop;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/video.js